import { string } from 'yup';

export const validateEmail = (email) => {
  const schema = string()
    .email()
    .required();
  return schema.isValidSync(email);
};
